import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import { C8Node } from "src/c8-platform/type/node";
import SharedSpecSectionsMatrix from "src/SpecificationDataSheet/SharedSpecSectionsMatrix";
import AllComponentsTable from "./AllComponentsTable";

export = declare(SharedSpecSectionsMatrix, {
	/**
	 * @override
	 * get the column nodes
	 */
	_getColumnNodes(ctx: Context, h: Heading): C8Node[] | undefined {
		const view = ctx.view as unknown as typeof AllComponentsTable.prototype;
		return view.sharedSections;
	},
});